export interface PtouchEntry {
    zip: string,
    address: string,
    name: string,
}

export function parseCombinedAddress(addrstr: string) : { zip: string, address: string } {
    const zipmatch = addrstr.match(/〒([0-9]{3})-?([0-9]{4}) (.*)/);
    if(!zipmatch || zipmatch.length < 4) throw new Error("Address Format Error: " + addrstr);

    return {
        zip: zipmatch[1] + "-" + zipmatch[2],
        address: zipmatch[3]
    };
}

export function generateCSV(entries: PtouchEntry[]): string {
    return entries.reduce((s, x) => s + `${x.zip},${x.address},${x.name}\n`, '');
}
